import React from 'react'

function ServiceProvider() {
  return (
    <div>serviceProvider</div>
  )
}

export default ServiceProvider